import { resolveAppPath } from "./domain/deployment.ts";

export const isPublicDeployment = import.meta.env.VITE_PUBLIC_DEPLOYMENT === "1";

export const paidUpgradeUrl =
  import.meta.env.VITE_PAID_UPGRADE_URL?.trim() ||
  "https://paibanpai.cn/index.html?service=english&source=free-sci#english";

export function appPath(value: string): string {
  return resolveAppPath(import.meta.env.BASE_URL, value);
}
